import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9c5e95a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "voc-file-uploader-container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  class: "label"
}
const _hoisted_4 = {
  key: 0,
  class: "required"
}
const _hoisted_5 = { class: "file-uploaders-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-modal-body-text" }, [
  /*#__PURE__*/_createTextVNode(" 대체 텍스트는 시각장애인을 위한 설명입니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("예) \"버스 내부 사진 - 실내온도계 영하 7도\" ")
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($props.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
            _createTextVNode(_toDisplayString($props.label), 1 /* TEXT */),
            ($props.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" <div class=\"guide-fallback-text\">\n        <button type=\"button\" @click=\"toggleShowFallbackTextGuideModal(true)\">\n          <span>\n            <InlineSvg :src=\"require('@/assets/icons/fi-help-circle.svg')\" />\n          </span>\n          <span> 대체 텍스트 안내 </span>\n        </button>\n      </div> ")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode($setup["FileInput"], {
        class: "file-uploader",
        fileInputUid: "0",
        fileInfos: $setup.getFileInfos(0),
        editMode: $props.editMode,
        onOnAddedFiles: $setup.emitOnAddedFiles,
        onOnDeletedFile: $setup.emitOnDeletedFiles
      }, null, 8 /* PROPS */, ["fileInfos", "editMode"]),
      _createVNode($setup["FileInput"], {
        class: "file-uploader",
        fileInputUid: "1",
        fileInfos: $setup.getFileInfos(1),
        editMode: $props.editMode,
        onOnAddedFiles: $setup.emitOnAddedFiles,
        onOnDeletedFile: $setup.emitOnDeletedFiles
      }, null, 8 /* PROPS */, ["fileInfos", "editMode"])
    ]),
    ($setup.shouldShowFallbackTextGuideModal)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 0,
          title: "대체텍스트 안내",
          okButtonTitle: "확인",
          onOnClickOkButton: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowFallbackTextGuideModal(false)))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}